import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import DevOpsSubscriptionsStore from "./DevOpsSubscriptionsStore";

const devopsSubscriptionsRoute: RouteType[] = [
  {
    name: "DevOps Subscriptions",
    path: "/devops/subscriptions",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Subscriptions",
        enableRefreshButton: true,
        component: () => import("./DevOpsSubscriptions.Header"),
      },
      body: {
        component: () => import("./DevOpsSubscriptions.Body"),
        grayBackground: true,
      },
    },
    group: "DevOps",
    searchAliases: ["webhooks", "ado events", "service hooks", "azure devops"],
    // Reads (listing the registered service hooks) require authentication only
    // (viewer+); the API enforces the read gate. Create/remove are
    // operator/admin — gated in the store (`canManage`) and enforced by the
    // API RBAC seam (`requireActionAccess`).
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.devopsSubscriptionsViewStore as DevOpsSubscriptionsStore;
      store?.initialize();
    },
    dialogs: [
      {
        name: "DevOpsSubscriptionFormDialog",
        title: "Add Subscription",
        submitButtonText: "Add subscription",
        component: () => import("./dialogs/DevOpsSubscriptionForm.Body"),
        cancelButton: true,
        height: 480,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          const store =
            rootStore.devopsSubscriptionsViewStore as DevOpsSubscriptionsStore;
          const ok = await store.saveSubscription();
          // Throwing keeps the dialog open so the API error (bad PAT / missing
          // service-hook permission) stays visible in the form's alert.
          if (!ok) {
            throw new Error(store.formError || "Failed to create subscription");
          }
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
          const store =
            rootStore.devopsSubscriptionsViewStore as DevOpsSubscriptionsStore;
          return store.isFormValid;
        },
      },
    ],
  },
];

export default devopsSubscriptionsRoute;
